import script from "./firm-inbox-sort-dropdown.vue?vue&type=script&setup=true&lang=ts"
export * from "./firm-inbox-sort-dropdown.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__